import request from "@/utils/request";
import config from "@/utils/config";
import {handleUrlEncode} from "@/utils/urlutil";

/**
 * 后台添加起始页广告轮播图
 * @param param
 * @returns {*}
 */
export function addSlideImageBanner(param) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminSlideImage/Banner/Add",
        method: "post",
        data: param,
    })
}

/**
 * 后台删除或者恢复指定起始页广告轮播图
 * @param param
 * @returns {*}
 */
export function deleteSlideImageBannerOrBack(param) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminSlideImage/Banner/DeleteOrBack",
        method: "delete",
        params: param,
    })
}

/**
 * 后台分页获取起始页广告轮播图集合
 * @param param
 * @returns {*}
 */
export function getSlideImageBannerList(param) {
    let url = config.API_ADMIN + "/Api/V1/AdminSlideImage/Banner/List?"
    url = handleUrlEncode(url, param)
    return request({
        url: url,
        method: "get",
    })
}

/**
 * 后台获取指定起始页广告轮播图详情
 * @param param
 * @returns {*}
 */
export function getSlideImageBannerOne(param) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminSlideImage/Banner/One",
        method: "get",
        params: param,
    })
}

/**
 * 后台更新起始页广告轮播图
 * @param param
 * @returns {*}
 */
export function updateSlideImageBanner(param) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminSlideImage/Banner/Update",
        method: "post",
        data: param,
    })
}

/**
 * 后台添加超人圈群组轮播图
 * @param param
 * @returns {*}
 */
export function addForumGroupSliderImage(param) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminSlideImage/ForumGroupSliderImage/Add",
        method: "post",
        data: param,
    })
}

/**
 * 后台删除或者恢复指定超人圈群组轮播图
 * @param param
 * @returns {*}
 */
export function deleteForumGroupSliderImageOrBack(param) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminSlideImage/ForumGroupSliderImage/DeleteOrBack",
        method: "delete",
        params: param,
    })
}

/**
 * 后台分页获取超人圈群组轮播图集合
 * @param param
 * @returns {*}
 */
export function getForumGroupSliderImageList(param) {
    let url = config.API_ADMIN + "/Api/V1/AdminSlideImage/ForumGroupSliderImage/List?"
    url = handleUrlEncode(url, param)
    return request({
        url: url,
        method: "get",
    })
}

/**
 * 后台获取指定超人圈群组轮播图详情
 * @param param
 * @returns {*}
 */
export function getForumGroupSliderImageOne(param) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminSlideImage/ForumGroupSliderImage/One",
        method: "get",
        params: param,
    })
}

/**
 * 后台更新指定超人圈群组轮播图
 * @param param
 * @returns {*}
 */
export function updateForumGroupSliderImage(param) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminSlideImage/ForumGroupSliderImage/Update",
        method: "post",
        data: param,
    })
}

/**
 * 后台添加麦粒首页轮播图
 * @param param
 * @returns {*}
 */
export function addLiveSliderImage(param) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminSlideImage/LiveSlideImage/Add",
        method: "post",
        data: param,
    })
}

/**
 * 后台删除或者恢复指定麦粒首页轮播图
 * @param param
 * @returns {*}
 */
export function deleteLiveSliderImageOrBack(param) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminSlideImage/LiveSlideImage/DeleteOrBack",
        method: "delete",
        params: param,
    })
}

/**
 * 后台分页获取麦粒首页轮播图集合
 * @param param
 * @returns {*}
 */
export function getLiveSliderImageList(param) {
    let url = config.API_ADMIN + "/Api/V1/AdminSlideImage/LiveSlideImage/List?"
    url = handleUrlEncode(url, param)
    return request({
        url: url,
        method: "get",
    })
}

/**
 * 后台获取指定麦粒首页轮播图详情
 * @param param
 * @returns {*}
 */
export function getLiveSliderImageOne(param) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminSlideImage/LiveSlideImage/One",
        method: "get",
        params: param,
    })
}

/**
 * 后台更新麦粒首页轮播图
 * @param param
 * @returns {*}
 */
export function updateLiveSliderImage(param) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminSlideImage/LiveSlideImage/Update",
        method: "post",
        data: param,
    })
}

/**
 * 后台添加产品轮播图
 * @param param
 * @returns {*}
 */
export function addProductSliderImage(param) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminSlideImage/ProductSlideImage/Add",
        method: "post",
        data: param,
    })
}

/**
 * 后台删除或者恢复指定产品轮播图
 * @param param
 * @returns {*}
 */
export function deleteProductSliderImageOrBack(param) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminSlideImage/ProductSlideImage/DeleteOrBack",
        method: "delete",
        params: param,
    })
}

/**
 * 后台分页获取产品轮播图集合
 * @param param
 * @returns {*}
 */
export function getProductSliderImageList(param) {
    let url = config.API_ADMIN + "/Api/V1/AdminSlideImage/ProductSlideImage/List?"
    url = handleUrlEncode(url, param)
    return request({
        url: url,
        method: "get",
    })
}

/**
 * 后台获取指定产品轮播图详情
 * @param param
 * @returns {*}
 */
export function getProductSliderImageOne(param) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminSlideImage/ProductSlideImage/One",
        method: "get",
        params: param,
    })
}

/**
 * 更新添加产品轮播图
 * @param param
 * @returns {*}
 */
export function updateProductSliderImage(param) {
    return request({
        url: config.API_ADMIN + "/Api/V1/AdminSlideImage/ProductSlideImage/Update",
        method: "post",
        data: param,
    })
}